import { Backdrop, Box, CircularProgress } from "@mui/material";
import React, { Suspense, lazy, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { cfpBaseUrl } from "../../network/urls";
import { filterDataByDuration, getShortMonthName, mergeWithDefaultCFCData, mergeWithDefaultData } from "../../services/Functions";
import "./CfcDashboard.scss";
import CommercialServicesCardLoading from "../../components/commercialServicesCard/CommercialServicesCardLoading";
import DashboardHeaderLoading from "../../components/cfcDashboard/DashboardHeaderLoading";
// Lazy load DashboardHeader and InfoCard
const CommercialServicesCard = lazy(() => import("../../components/commercialServicesCard/CommercialServicesCard"));
const DashboardHeader = lazy(() => import("../../components/cfcDashboard/DashboardHeader"));

const CommercialOperations = () => {
    const [viewBackdrop, setViewBackdrop] = useState(false);

    const { token, code, cfcLevelId } = useSelector(state => state.auth)

    const [hierarchicalCFCStats, setHierarchicalCFCStats] = useState([
        {
            cfcName: 'Circle CFC 1',
            servicesStats: [
                { service: "New Connections", pending: 120, attended: 21, total: 141 },
                {
                    service: "Bill Installments",
                    pending: 120,
                    attended: 21,
                    total: 141,
                },
                {
                    service: "Due Date Extensions",
                    pending: 120,
                    attended: 21,
                    total: 141,
                },
                { service: "Change of Attributes", pending: 120, attended: 21, total: 141 },
                { service: "Reconnection", pending: 120, attended: 21, total: 141 },

            ]
        },
        {
            cfcName: 'Circle CFC 2',
            servicesStats: [
                { service: "New Connections", pending: 120, attended: 21, total: 141 },
                
                {
                    service: "Bill Installments",
                    pending: 120,
                    attended: 21,
                    total: 141,
                },
                {
                    service: "Due Date Extensions",
                    pending: 120,
                    attended: 21,
                    total: 141,
                },
               
                { service: "Change of Attributes", pending: 120, attended: 21, total: 141 },
                { service: "Reconnection", pending: 120, attended: 21, total: 141 },

            ]
        },
        {
            cfcName: 'Circle CFC 3',
            servicesStats: [
                { service: "New Connections", pending: 120, attended: 21, total: 141 },
                {
                    service: "Bill Installments",
                    pending: 120,
                    attended: 21,
                    total: 141,
                },
                {
                    service: "Due Date Extensions",
                    pending: 120,
                    attended: 21,
                    total: 141,
                },
                { service: "Change of Attributes", pending: 120, attended: 21, total: 141 },
                { service: "Reconnection", pending: 120, attended: 21, total: 141 },
                // { service: "Change of Load", pending: 120, attended: 21, total: 141 },
                // { service: "Change of Tariff", pending: 120, attended: 21, total: 141 },
            ]
        }

    ]);

    const [serviceCards, setServiceCards] = useState([
        {
            service: "New Connections",
            title1: "New",
            title2: "Connections",
            yearlyCounter: 0,
            month: getShortMonthName(),
            monthlyCounter: 0,
            color: "#FFE2E5",
        },
        {
            service: "Bill Installments",
            title1: "Bill",
            title2: "Installments",
            yearlyCounter: 0,
            month: getShortMonthName(),
            monthlyCounter: 0,
            color: "#EBDBFE",
        },
        {
            service: "Due Date Extensions",
            title1: "Due Date",
            title2: "Extensions",
            yearlyCounter: 0,
            month: getShortMonthName(),
            monthlyCounter: 0,
            color: "#FEF5C0",
        },
        {
            service: "Change of Attributes",
            title1: "Change of",
            title2: "Attributes",
            yearlyCounter: 0,
            month: getShortMonthName(),
            monthlyCounter: 0,
            color: "#FBE2CC",
        },
        {
            service: "Reconnection",
            title1: "Reconnection",
            // title2: "Name",
            yearlyCounter: 0,
            month: getShortMonthName(),
            monthlyCounter: 0,
            color: "#FBE2CC",
        },
    ])

    const [cfcStats, setCFCStats] = useState({
        cfcName: 'Test Regional CFC',
        servicesStats: [
            {
                Service: "Due Date Extensions",
                Attended: 31,
                Pending: 142,
                Total: 173,
                Duration: "Progressive"
            },
            {
                Service: "Change of Tariff",
                Attended: 32,
                Pending: 101,
                Total: 133,
                Duration: "Progressive"
            },
            
            {
                Service: "New Connections",
                Attended: 208,
                Pending: 148,
                Total: 356,
                Duration: "Progressive"
            },
            {
                Service: "Meter Change Requests",
                Attended: 21,
                Pending: 16,
                Total: 37,
                Duration: "Progressive"
            },
            {
                Service: "Bill Installments",
                Attended: 43,
                Pending: 77,
                Total: 120,
                Duration: "Progressive"
            },
            {
                Service: "Bill Installments",
                Attended: 8,
                Pending: 7,
                Total: 15,
                Duration: "Monthly"
            },
            {
                Service: "Bill Installments",
                Attended: 20,
                Pending: 15,
                Total: 35,
                Duration: "CurrentMonth"
            },
            
            {
                Service: "Change of Tariff",
                Attended: 1,
                Pending: 4,
                Total: 5,
                Duration: "Monthly"
            },
            {
                Service: "Due Date Extensions",
                Attended: 11,
                Pending: 6,
                Total: 17,
                Duration: "Monthly"
            },
            {
                Service: "New Connections",
                Attended: 20,
                Pending: 21,
                Total: 41,
                Duration: "Monthly"
            },
            {
                Service: "New Connections",
                Attended: 2,
                Pending: 4,
                Total: 6,
                Duration: "CurrentMonth"
            }
        ]
    },);

    const [officeCode, setOfficeCode] = useState(code)
    const [levelId, setLevelId] = useState(cfcLevelId)

    const updateOfficeCode = (newCode, newLevelId) => {
        if (newCode && newLevelId) {
            setLevelId(newLevelId)
            setOfficeCode(newCode)
        }
    }

    useEffect(() => {
        const getCFCStats = async () => {
            if (officeCode) {
                try {
                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", token);

                    const formdata = new FormData();
                    formdata.append("officeCode", (officeCode == "10" || officeCode == "15") ? "1500001" : officeCode);

                    const requestOptions = {
                        method: "POST",
                        headers: myHeaders,
                        body: formdata,
                        redirect: "follow"
                    };

                    await fetch(cfpBaseUrl + "comman/getCFCDashboardStats", requestOptions)
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.status === "200") {
                                let cfcName = result.cfcInformation[0].cfcName
                                let cfcServices = result.data
                                let cfcServicesCumulative = result.Cumulative
                                console.log(cfcServicesCumulative, 'cfcServicesCumulative')
                                if (cfcServicesCumulative) {
                                    const mergedData = mergeWithDefaultData(cfcServicesCumulative);
                                    const mergedLowerCardData = mergeWithDefaultCFCData(cfcServices)
                                    let servicesStatesLowerCard = mergedLowerCardData
                                    if (mergedData) {
                                        const yearlyData = filterDataByDuration(mergedData, 'Progressive')
                                        const currentMonthData = filterDataByDuration(mergedData, 'CurrentMonth')
                                        let serviceStats = serviceCards

                                        console.log(serviceStats, 'serviceStats before mapping')
                                        serviceStats.map(item => {
                                            yearlyData.forEach(data => {
                                                if (item.service === data.service) {
                                                    item.yearlyCounter = data.total
                                                }
                                            })
                                            currentMonthData.forEach(data => {
                                                if (item.service === data.service) {
                                                    item.monthlyCounter = data.total
                                                }
                                            })
                                        })
                                        setServiceCards(serviceStats)
                                    }
                                    setCFCStats({
                                        cfcName: cfcName,
                                        servicesStats: servicesStatesLowerCard
                                    })
                                }
                            }
                        })
                        .catch((error) => console.error(error));
                }
                catch (e) {
                    console.log(e, 'printing error!')
                }
            }
        }
        getCFCStats()
    }, [officeCode])

    useEffect(() => {
        const getChildrenCFCStats = async () => {
            if (officeCode) {
                try {
                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", token);
                    myHeaders.append("Content-Type", "application/json");

                    const raw = JSON.stringify({
                        "cfcLevel": levelId,
                        "cfcId": officeCode
                    });

                    const requestOptions = {
                        method: "POST",
                        headers: myHeaders,
                        body: raw,
                        redirect: "follow"
                    };

                    await fetch(cfpBaseUrl + "comman/getCFCChildernStatsOfficeWise", requestOptions)
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.status === "200") {
                                let allChildrenCFCServices = result.data
                                let childrenList = result.chilledCFCDetails
                                childrenList = childrenList.map((item) => (
                                    {
                                        ...item,
                                        servicesStats: allChildrenCFCServices.filter((itm) => itm.cfcId == item.cfcId)
                                    }
                                ))
                                childrenList.forEach((item) => {
                                    if (item.servicesStats) {
                                        item.servicesStats = mergeWithDefaultCFCData(item.servicesStats);
                                    }
                                });
                                setHierarchicalCFCStats(childrenList)
                            }
                        })
                        .catch((error) => console.error(error));
                }
                catch (e) {
                    console.log(e, 'printing error!')
                }
            }
        }
        getChildrenCFCStats()
    }, [officeCode])

    return (
        <>
            <Box className="form-box">
                <div className="cfc-dashboard">
                    <Suspense fallback={<DashboardHeaderLoading />}>
                        <DashboardHeader
                            title="Customer Services"
                            serviceCards={serviceCards}
                        />
                    </Suspense>
                    <div style={{ display: 'grid', gridTemplateColumns: 'auto auto', gap: '15px' }}>
                        <Suspense fallback={<CommercialServicesCardLoading />}>
                            <CommercialServicesCard item={cfcStats} primary={true} />
                        </Suspense>
                        {
                            hierarchicalCFCStats.map((item, index) => (
                                <div key={index}>
                                    <Suspense fallback={<CommercialServicesCardLoading />}>
                                        <CommercialServicesCard item={item} updateOfficeCode={updateOfficeCode} />
                                    </Suspense>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </Box>

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >

        </>
    );
};

export const getRowsData = () => [
    { service: "New Connections", pending: 120, attended: 21, total: 141 },
    {
        service: "Bill Installments",
        pending: 120,
        attended: 21,
        total: 141,
    },
    {
        service: "Due Date Extensions",
        pending: 120,
        attended: 21,
        total: 141,
    },
    { service: "Change of Attributes", pending: 120, attended: 21, total: 141 },
    // { service: "Change of Load", pending: 120, attended: 21, total: 141 },
    // { service: "Change of Tariff", pending: 120, attended: 21, total: 141 },
];

export default CommercialOperations;
